/* eslint-disable import/no-cycle */
import React from "react";
import { SvgProps } from ".";

export const Twitter: React.FC<SvgProps> = ({ fill, height, width }) => (
  <svg
    aria-labelledby="Twitter "
    height={height || "40px"}
    viewBox="0 0 35 35"
    version="1.1"
    width={width || "40px"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="twitter-svg">Twitter</title>
    <g
      id="Resource-Center"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Important-links-sidebar"
        transform="translate(-1037.000000, -450.000000)"
        fill={fill || "#252525"}
      >
        <g id="Group-4" transform="translate(1036.000000, 410.000000)">
          <g id="twitter" transform="translate(1.000000, 40.000000)">
            <path
              d="M17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 Z M21.1102907,11.1363636 C19.2179521,11.1363636 17.6844715,12.7547339 17.6844715,14.7505515 C17.6844715,15.0338956 17.7129056,15.3100009 17.7717348,15.573697 C14.9244025,15.4227181 12.3996502,13.9853157 10.7083113,11.7971551 C10.4131849,12.3328201 10.2445413,12.9532816 10.2445413,13.6151071 C10.2445413,14.8684392 10.8495014,15.9749288 11.7691975,16.6243451 C11.2073789,16.6057312 10.6788967,16.4413089 10.2161072,16.1724423 L10.2161072,16.2169087 C10.2161072,17.9686782 11.3966127,19.4298649 12.9663713,19.7607776 C12.6781083,19.845574 12.3761186,19.8879722 12.0623629,19.8879722 C11.8417535,19.8879722 11.6260465,19.8662561 11.4181834,19.8238579 C11.8535193,21.259192 13.1193272,22.3057036 14.6194713,22.3336244 C13.4458291,23.3036125 11.9682362,23.8806416 10.3631801,23.8806416 C10.086683,23.8806416 9.81312731,23.8651301 9.54545455,23.8310047 C11.0622669,24.8558002 12.8634203,25.4545455 14.7989003,25.4545455 C21.1034273,25.4545455 24.5488562,19.9469161 24.5488562,15.1703971 C24.5488562,15.0132135 24.5468953,14.8570641 24.5400319,14.7029828 C25.209704,14.1931703 25.7921129,13.5561633 26.25,12.8312575 C25.6352351,13.1187379 24.9743873,13.3131492 24.282164,13.4000138 C24.9900751,12.9532816 25.5332645,12.2449214 25.7881909,11.4010939 C25.1253822,11.8157689 24.3929589,12.1156586 23.6115113,12.2780127 C22.987922,11.5748231 22.0966599,11.1363636 21.1102907,11.1363636 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default {};
